import type { GenerationRuleKind } from './generation-rule-labels'

/** The kinds a new or edited rule may take beside the salary setting's other
 * rules: one rule per output, and a rule for both outputs stands alone. */
export function freeRuleKinds(
  otherKinds: string[],
  salaryDaysAllowed: boolean
): GenerationRuleKind[] {
  if (otherKinds.includes('both')) return []
  const free: GenerationRuleKind[] = []
  if (!otherKinds.includes('diet')) free.push('diet')
  if (salaryDaysAllowed && !otherKinds.includes('salary_day'))
    free.push('salary_day')
  if (salaryDaysAllowed && otherKinds.length === 0) free.push('both')
  return free
}
